import { COMMERCETOOLS_API_URL } from "@lib/constants/urlConstants";
import type { DocumentNode } from "graphql";
import fetch from "../helpers/fetchWithLogging";
import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";
import type { Client } from "@urql/core";
import { createClient } from "@urql/core";

function makeClient(): Client {
    return createClient({
        url: `${COMMERCETOOLS_API_URL}/${process.env.NEXT_PUBLIC_COMMERCETOOLS_PROJECT_KEY}/graphql`,
        fetch: fetch,
        requestPolicy: "network-only",
    });
}
class GraphQlClientWrapper {
    private async query<Data = any, Variables extends object = object>(
        query: string | DocumentNode,
        serviceEndpoint: ServiceType,
        variables?: Variables
    ) {
        const startTime = performance.now();
        const result = await makeClient().query<Data, Variables>(query, variables).toPromise();

        Logger.info(serviceEndpoint, `${serviceEndpoint} Query Time`, {
            tag: LogTag.PERFORMANCE,
            duration: performance.now() - startTime,
        });

        if (result.error) {
            Logger.error(serviceEndpoint, `${serviceEndpoint} Query Error`, {
                tag: LogTag.ERROR,
                error: result.error,
            });
        }

        return result;
    }

    async queryCommerceTools<Data = any, Variables extends object = object>(
        query: string | DocumentNode,
        variables?: Variables
    ) {
        return this.query<Data, Variables>(query, ServiceType.COMMERCE_TOOLS, variables);
    }
}

const graphQlClient = new GraphQlClientWrapper();

export { graphQlClient };
